<template>
  <footer class="footer" role="contentinfo" aria-label="Rodapé da Fundação FFJB">
    <div class="footer-container">
      <!-- Coluna do Logotipo -->
      <div class="footer-logo">
        <img
          src="@/assets/images/ffjblogo.jpg"
          alt="Logotipo da Fundação FFJB"
          class="logo-img"
          loading="lazy"
        />
      </div>

      <!-- Coluna 1: Contatos -->
      <div class="footer-column">
        <h3>Contactos</h3>
        <p><font-awesome-icon icon="phone" /> +244 922 488 863</p>
        <p><font-awesome-icon icon="envelope" /> contacto@ffjb.ao</p>
        <p><font-awesome-icon icon="map-marker-alt" /> Rua Guiné Bissau,  Lobito - Angola</p>
      </div>

      <!-- Coluna 2: Links Rápidos -->
      <div class="footer-column">
        <h3>Links Rápidos</h3>
        <ul>
          <li><a href="/servicos">Serviços</a></li>
          <li><a href="/contacto">Contato</a></li>
          <li><a href="/blog">Blog</a></li>
          <li><a href="/projetos">Projetos</a></li>
        </ul>
      </div>

      <!-- Coluna 3: Redes Sociais -->
      <div class="footer-column">
        <h3>Siga-nos</h3>
        <div class="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61557384655175" target="_blank" aria-label="Facebook FFJB">
            <font-awesome-icon icon="fa-brands fa-facebook" />
          </a>
          <a href="https://instagram.com/ffjb" target="_blank" aria-label="Instagram FFJB">
            <font-awesome-icon icon="fa-brands fa-instagram" />
          </a>
          <a href="https://linkedin.com/ffjb" target="_blank" aria-label="LinkedIn FFJB">
            <font-awesome-icon icon="fa-brands fa-linkedin" />
          </a>
          <a href="https://wa.me/244922488863" target="_blank" aria-label="WhatsApp FFJB">
            <font-awesome-icon icon="fa-brands fa-whatsapp" />
          </a>
        </div>
      </div>
    </div>

    <!-- Descrição breve da empresa -->
    <div class="footer-description">
      <p>
        FFJB é uma empresa especializada na prestação de serviços em eletrônica, eletricidade civil e industrial, climatização, automação, manutenção de máquinas, elevadores, portas automáticas, eletromecânica e telecomunicações
        Comprometida com a qualidade, inovação e satisfação dos clientes.
      </p>
    </div>

    <!-- Parte inferior -->
    <div class="footer-bottom">
      <p>&copy; 2025 Todos os direitos reservados, FFJB - Soluções em eletrônica, eletricidade civil e industrial, climatização, automação, manutenção de máquinas, elevadores, portas automáticas, eletromecânica e telecomunicações</p>
      <p>
        Desenvolvido por:
        <a href="https://www.ergab.ao" target="_blank" rel="noopener noreferrer">ERGAB, LDA</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FfjbFooter',
};
</script>

<style scoped>
.footer {
  background-color: #002244;
  color: #ffffff;
  padding: 40px 20px 20px;
  font-family: Arial, sans-serif;
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;
  max-width: 1200px;
  margin: auto;
}

.footer-logo {
  flex: 1 1 200px;
  text-align: center;
}

.logo-img {
  max-width: 150px;
  height: auto;
  object-fit: contain;
}

.footer-column {
  flex: 1 1 220px;
  min-width: 220px;
}

.footer-column h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #0fdf8a;
}

.footer-column p,
.footer-column li {
  margin-bottom: 10px;
  font-size: 15px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column a {
  color: #ffffff;
  text-decoration: none;
}

.footer-column a:hover {
  text-decoration: underline;
  color: #0fdf8a;
}

.social-icons {
  display: flex;
  gap: 15px;
  font-size: 22px;
}

.footer-description {
  max-width: 900px;
  margin: 25px auto;
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  color: #cccccc;
}

.footer-bottom a {
  color: #ffffff;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
  color: #0fdf8a;
}
.footer-bottom {
  border-top: 1px solid #0fdf8a;
  margin-top: 30px;
  text-align: center;
  padding-top: 15px;
  font-size: 14px;
  color: #cccccc;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
  }

  .footer-column,
  .footer-logo {
    text-align: center;
  }

  .logo-img {
    margin-bottom: 20px;
  }
}
</style>
